var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-text-field',{attrs:{"dense":"","label":_vm.$t('incidentReports.absenceInDays'),"data-cy":"unableToWorkDays"},model:{value:(_vm.value.unableToWorkDays),callback:function ($$v) {_vm.$set(_vm.value, "unableToWorkDays", $$v)},expression:"value.unableToWorkDays"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }